import { useState } from 'react'
import Input from '../../../../Core/Fields/Floating/Input';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import { useGetCountryListQuery } from '../../../../store/api/companyapi'
import { useGetTaxcategoryQuery } from '../../../../store/api/customer'
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
const Tab1 = ({ pageState, handleChange, onInputChange }) => {




    const stateOptions = [
        { "name": "Andhra Pradesh" },
        { "name": "Arunachal Pradesh" },
        { "name": "Assam" },
        { "name": "Bihar" },
        { "name": "Chhattisgarh" },
        { "name": "Goa" },
        { "name": "Gujarat" },
        { "name": "Haryana" },
        { "name": "Himachal Pradesh" },
        { "name": "Jharkhand" },
        { "name": "Karnataka" },
        { "name": "Kerala" },
        { "name": "Madhya Pradesh" },
        { "name": "Maharashtra" },
        { "name": "Manipur" },
        { "name": "Meghalaya" },
        { "name": "Mizoram" },
        { "name": "Nagaland" },
        { "name": "Odisha" },
        { "name": "Punjab" },
        { "name": "Rajasthan" },
        { "name": "Sikkim" },
        { "name": "Tamil Nadu" },
        { "name": "Telangana" },
        { "name": "Tripura" },
        { "name": "Uttar Pradesh" },
        { "name": "Uttarakhand" },
        { "name": "West Bengal" },
        { "name": "Andaman and Nicobar Islands" },
        { "name": "Chandigarh" },
        { "name": "Dadra and Nagar Haveli and Daman and Diu" },
        { "name": "Delhi" },
        { "name": "Jammu and Kashmir" },
        { "name": "Ladakh" },
        { "name": "Lakshadweep" },
        { "name": "Puducherry" }
    ]
    const addrsstype = [{ "name": "Billing" }, { "name": "Shipping" }, { "name": "Office" }, { "name": "Personal" }, { "name": "Plant" }, { "name": "Postal" }, { "name": "Shop" }, { "name": "Subssidiary" }, { "name": "Warehouse" }, { "name": "Current" }, { "name": "Permananent" }, { "name": "Other" }]

    const [selectedCompany, setSelectedCompany] = useState('')
    const [isGroup, setIsGroup] = useState(0)
    const { data: countrydata, isLoading: countryLoader } = useGetCountryListQuery();
    const { data: taxcatData, taerror, taisLoading } = useGetTaxcategoryQuery();



    return (
        <div>
            <div className="px-3 py-4" style={{ background: 'white' }}>
                <div className="mb-3" style={{ display: 'flex', gap: '20px' }} >
                    <div className="col-md-12" style={{ display: 'flex' }} >
                        <div className="col-md-6 px-2">
                            <div className='' style={{ backgroundColor: '#EBE6FA', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                                <div style={{ display: 'flex', gap: '15px' }}>
                                    <div style={{ flex: 1 }}>
                                        <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}>Address Details</p>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '15px' }}>
                                    <div style={{ flex: 1 }}>

                                        <Input
                                            name="addressTitle"
                                            value={pageState.addressTitle}
                                            onChange={(e) => handleChange('addressTitle', e.target.value)}
                                            label="Address Title"
                                            style={{ height: "30px" }}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <SelectSearch
                                            list={addrsstype || []}
                                            label="Customer Type"
                                            value={pageState.AddressType}
                                            onChange={(val) => handleChange('AddressType', val)}
                                            getOptionLabel={(item) => item.name}
                                            getOptionValue={(item) => item.name}
                                            placeholder=""
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <Input
                                            name="AddressLine1"
                                            value={pageState.AddressLine1}
                                            label="Address Line1"
                                            onChange={(e) => handleChange('AddressLine1', e.target.value)}
                                            style={{ height: "30px" }}
                                        />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '15px' }}>
                                    <div style={{ flex: 1 }}>
                                        <Input
                                            name="AddressLine2"
                                            value={pageState.AddressLine2}
                                            label="Address Line2"
                                            onChange={(e) => handleChange('AddressLine2', e.target.value)}
                                            style={{ height: "30px" }}
                                        />
                                    </div>

                                    <div style={{ flex: 1 }}>
                                        <SelectSearch
                                            list={countrydata?.data || []}
                                            label="County"
                                            value={pageState.Country}
                                            onChange={(val) => handleChange('Country', val)}

                                            getOptionLabel={(item) => item.name}
                                            getOptionValue={(item) => item.name}
                                            placeholder=""
                                        />
                                    </div>


                                    <div style={{ flex: 1 }}>
                                        <SelectSearch
                                            list={stateOptions || []}
                                            label="State/Province"
                                            value={pageState.State}
                                            onChange={(val) => handleChange('State', val)}

                                            getOptionLabel={(item) => item.name}
                                            getOptionValue={(item) => item.name}
                                            placeholder=""
                                        />
                                    </div>


                                </div>

                            </div>
                        </div>

                        <div className="col-md-6 px-2">
                            <div className='' style={{ backgroundColor: '#E3F5DF', height: "100%", borderRadius: '4px', display: 'flex', flexDirection: 'column', width: '100%', padding: '10px' }}>
                                <div style={{ display: 'flex', gap: '15px' }}>
                                    <div style={{ flex: 1, height: '22px' }}>
                                        <p className='m-0' style={{ fontSize: '16px', fontWeight: '600' }}></p>
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '15px' }}>


                                    <div style={{ flex: 1 }}>
                                        <Input
                                            name='City'
                                            label="City/Town"
                                            value={pageState.City}
                                            onChange={(e) => handleChange('City', e.target.value)}
                                            style={{ height: "30px" }}
                                        />
                                    </div>

                                    <div style={{ flex: 1 }}>

                                        <Input
                                            name='postalCode'
                                            label="Postal Code"
                                            value={pageState.postalCode}
                                            onChange={(e) => handleChange('postalCode', e.target.value)}
                                            style={{ height: "30px" }}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <Input
                                            label="Email Address"
                                            name='email'
                                            value={pageState.email}
                                            onChange={(e) => handleChange('email', e.target.value)}
                                            style={{ height: "30px" }}
                                        />
                                    </div>
                                </div>
                                <div style={{ display: 'flex', gap: '15px' }}>

                                    <div style={{ flex: 1 }}>

                                        <Input
                                            label="Phone"
                                            name='phone'
                                            value={pageState.phone}
                                            onChange={(e) => handleChange('phone', e.target.value)}
                                            style={{ height: "30px" }}
                                        />


                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <Input
                                            name='Fax'
                                            label="Fax"
                                            value={pageState.Fax}
                                            onChange={(e) => handleChange('Fax', e.target.value)}
                                            style={{ height: "30px" }}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        <SelectSearch
                                            list={taxcatData?.data || []}
                                            label="Tax Category"
                                            value={pageState.taxCategory}
                                            onChange={(val) => handleChange('taxCategory', val)}

                                            getOptionLabel={(item) => item.name}
                                            getOptionValue={(item) => item.name}
                                            placeholder=""
                                        />

                                    </div>


                                </div>
                                <div style={{ display: 'flex', gap: '15px' }}>

                                    <div style={{ flex: 1 }}>
                                        {/* <label style={{ height: '19px' }}></label> */}
                                        <Checkbox
                                            id="PreferredBillingAddress"
                                            label="Preferred Billing Address"
                                            checked={pageState.pba || false}
                                            onChange={(checked) => onInputChange("pba", checked)}
                                        />

                                    </div>
                                    <div style={{ flex: 1 }}>
                                        {/* <label style={{ height: '19px' }}></label> */}
                                        <Checkbox
                                            id="PreferredShippingAddress"
                                            label="Preferred Shipping Address"
                                            checked={pageState.psa || false}
                                            onChange={(checked) => onInputChange("psa", checked)}
                                        />
                                    </div>
                                    <div style={{ flex: 1 }}>
                                        {/* <label style={{ height: '19px' }}></label> */}
                                        <Checkbox
                                            id="Disabled"
                                            label="Disabled"
                                            checked={pageState.Disabled || false}
                                            onChange={(checked) => onInputChange("Disabled", checked)}
                                        />

                                    </div>


                                </div>



                            </div>
                        </div>
                    </div>
                </div>


            </div>

        </div>
    )
}

export default Tab1